import React from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap'
import moment from 'moment';
import './style.css'

export default function UserTable(props) {

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h4 style={{ color: '#3a3a3c', fontWeight: 600, marginBottom: 16 }}>{props.title}</h4>
                    </Col>
                    <Row className='gameTableContainer' >
                        <Table responsive >

                            <thead>
                                <tr className="tableHead" >
                                    <th>Date</th>
                                    <th>Home</th>
                                    <th>Away</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    props.data?.map((data, index) => (
                                        <tr key={index}>
                                            <td style={{ fontWeight: 500, fontSize: 14 }}>
                                                {moment().format('dddd DD MMMM yyyy HH:MM')}
                                            </td>
                                            <td>
                                                <p style={{ fontSize: 14, lineHeight: 1.3, fontWeight: 500, margin: 0 }}>{data.teams.home.team}</p>
                                            </td>
                                            <td>
                                                <p style={{ fontSize: 14, lineHeight: 1.3, fontWeight: 500, margin: 0 }}>{data.teams.away.team}</p>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Row>
                </Row>
            </Container>
        </>
    )
}
